interface IDeclination {
    number: number;
    txt: string[];
    cases?: number[];
}

export const declination = ({number, txt, cases = [2, 0, 1, 1, 1, 2]}:IDeclination) => {
    return txt[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
};
